import React from 'react'
import Background from './Background'
import Products from './Products'

const Home = () => {
  return (
    <div>
      <Background/>
      <Products/>
    </div>
  )
}

export default Home
